"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const IconContainer_1 = __importStar(require("../IconContainer"));
const LockIcon = ({ size = IconContainer_1.DEFAULT_ICON_SIZE, ...rest }) => ((0, jsx_runtime_1.jsxs)(IconContainer_1.StyledSvg, { fill: "none", height: size, viewBox: "0 0 24 24", width: size, xmlns: "http://www.w3.org/2000/svg", ...rest, children: [(0, jsx_runtime_1.jsx)("path", { clipRule: "evenodd", d: "M16.889 9.21V6.722C16.889 4.11 14.693 2 12 2S7.111 4.109 7.111 6.722V9.21H4v10.972C4 21.179 4.85 22 5.882 22h12.236C19.15 22 20 21.192 20 20.182V9.21h-3.111zM14.47 6.722c0-1.313-1.111-2.386-2.471-2.386S9.53 5.409 9.53 6.722V9.21h4.94V6.722z", fillRule: "evenodd" }), (0, jsx_runtime_1.jsx)("path", { d: "M11.056 15.524a1.81 1.81 0 01-.796-1.504c0-.985.784-1.793 1.74-1.793s1.74.808 1.74 1.793c0 .63-.313 1.18-.784 1.499v3.047h-1.9v-3.042z", fill: "#fff" })] }));
exports.default = (0, IconContainer_1.default)(LockIcon);
//# sourceMappingURL=index.js.map